module.exports = __webpack_public_path__ + "static/FSS_HowItWorks2-ef2fb25d1fb487957641cb49eaf3924f.png";